import React from 'react';

import { Modal } from 'src/components/common';
import { InviteEmployersByPeoPpModalContent } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

type InviteEmployersByPeoPpModalProps = {
  peoPayrollProviderId?: string;
};

export const InviteEmployersByPeoPpModal: React.FC<InviteEmployersByPeoPpModalProps> = ({
  peoPayrollProviderId,
}) => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.InviteEmployersByPeoPp);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Add Employers"
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InviteEmployersByPeoPpModalContent
        closeModal={onCloseModal}
        switchClosability={switchClosability}
        peoPayrollProviderId={peoPayrollProviderId}
      />
    </Modal>
  );
};
